import React from 'react'

function TodayReport() {
  return (
    <div>TodayReport</div>
  )
}

export default TodayReport